<app-phone-number [number]="office.fax" [linkTo]="linkTo" [allowCopyToClipboard]="true" />
<a target="_blank" href="/capture-admin/offices/{{ office.id }}" *ngIf="canViewOffice">
  <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
</a>

